import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Navigate } from 'react-router-dom';
// hooks
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useSelector((state) => state.auth);


  if (isAuthenticated) {
    // Admins land on the metrics dashboard as their home page; everyone else
    // goes to the regular dashboard root.
    return <Navigate to={user?.is_staff ? PATH_DASHBOARD.admin.metrics : PATH_DASHBOARD.root} />;
  }

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
